export const SNAPSHOT_CURRENT_VIEW = 0xffffffff;
export var FilespaceState;
(function (FilespaceState) {
    FilespaceState["LINKED"] = "Linked";
    FilespaceState["UNLINKED"] = "Unlinked";
    FilespaceState["LINKING"] = "Linking";
    FilespaceState["UNLINKING"] = "Unlinking";
})(FilespaceState || (FilespaceState = {}));
